import { sectors } from "keys"
import { last } from "lodash"


class CreateAssessmentDef {

    constructor(assessmentDef) {
        const { text_draft, text_updated, status, words, pages, category, affiliation, adapted_by, publisher, version, source_passage, questions, title, id, year_published, author, name, sector, type, permission, relevancy_from, relevancy_to, readability_score } = assessmentDef

        if (id)
            this.id = id
        this.title = title
        this.name = name
        this.text_draft = text_draft
        if (text_updated && id)
            this.text_updated = text_updated
        this.status = status
        this.affiliation = affiliation?.id || affiliation
        this.adapted_by = adapted_by
        this.publisher = publisher?.id || publisher
        this.version = version
        this.author = author
        this.source_passage = source_passage?.id || source_passage
        this.type = type?.id || type
        this.readability_score = readability_score?.id || readability_score
        this.sector = sector?.id || sector || sectors.KLALI
        this.relevancy_from = relevancy_from?.id || relevancy_from
        this.relevancy_to = relevancy_to?.id || relevancy_to
        this.permission = permission?.id || permission || 'PUBLIC'
        this.year_published = year_published
        if (questions)
            this.questions = getQuestions(questions)
        if (pages)
            this.text = getText(pages)
        if (words)
            this.text = getWordsText(words)
    }
}

const getWordsText = (words) => {
    return words?.join(" ")
}

const getText = (pages) => {
    let text = ""

    const LTR = '\u200E';
    const SEP = LTR + '*' + LTR;
    const SEP_SPACE = LTR + ' *' + LTR;
    const PIPE = LTR + '|' + LTR;

    pages.forEach((page, index) => {
        if (!index) { // title page
            let titleText = page?.[0]
                .replace(/[ ]*(\r?\n)/g, '|$1')
                .replace(/ +$/g, '')
            text += `$${titleText}$`;
            text += "\n";
        } else {
            page?.forEach(singlePage => {
                if (singlePage) {
                    text += singlePage?.replace(/[ ]*(\r?\n)/g, '|$1')
                    if (last(text) == " ")
                        text += SEP
                    else text += SEP_SPACE;
                }
            });
        }
    });

    text = text.slice(0, -4)
    return text
}

const getQuestions = (nQuestions) => {
    let questions = []

    nQuestions.forEach((question, index) => {
        const answers = []
        question.answer_defs.forEach((answer, index) => {
            if (answer.text)
                answers.push({ ...answer, index: index })
        });
        if (question.text)
            questions.push({ ...question, index: index, answer_defs: answers })
    });

    return questions
}

export default CreateAssessmentDef